document.querySelectorAll("img[alt='clean label products']").forEach(img => {
    img.style.objectPosition = "top";
});

// Scroll to Yotpo reviews when clicking on product info Yotpo rating
document.addEventListener('DOMContentLoaded', function() {
    const yotpoElements = document.querySelectorAll('.product__info-container .yotpo');
    
    yotpoElements.forEach(function(element) {
        element.addEventListener('click', function(e) {
            const yotpoApp = document.querySelector('#yotpo-app');
            
            if (yotpoApp) {
                e.preventDefault();
                yotpoApp.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
        
        // Add cursor pointer to indicate clickability
        element.style.cursor = 'pointer';
    });
});



// TDEE Calculator js For Single Blog(Name :- TDEE Calculator) 

document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("tdeeCalculateBtn");
  if (!btn) return;

  btn.addEventListener("click", function () {

    let gender = document.getElementById("gender").value;
    let age = parseInt(document.getElementById("age").value);

    // Height
    let heightInput = parseFloat(document.getElementById("height").value);
    let heightUnit = document.getElementById("heightUnit").value;

    // Weight
    let weightInput = parseFloat(document.getElementById("weight").value);
    let weightUnit = document.getElementById("weightUnit").value;

    let activity = parseFloat(document.getElementById("activity").value);
    let outputDiv = document.getElementById("tdeeOutput");

    if (!age || !heightInput || !weightInput) {
      alert("Please fill all fields");
      return;
    }

    // Convert inch → cm
    let height = heightInput;
    if (heightUnit === "inch") {
      height = heightInput * 2.54;
    }

    // Convert lbs → kg
    let weight = weightInput;
    if (weightUnit === "lbs") {
      weight = weightInput * 0.45359237;
    }

    // BMR Calculation
    let BMR;
    if (gender === "male") {
      BMR = (10 * weight) + (6.25 * height) - (5 * age) + 5;
    } else {
      BMR = (10 * weight) + (6.25 * height) - (5 * age) - 161;
    }

    let TDEE = BMR * activity;

    outputDiv.style.display = "block";
    outputDiv.innerHTML =
      "Your TDEE is <strong>" + Math.round(TDEE) + " calories/day</strong>";

    // Reset fields
    document.getElementById("age").value = "";
    document.getElementById("height").value = "";
    document.getElementById("weight").value = "";
    document.getElementById("heightUnit").value = "cm";
    document.getElementById("weightUnit").value = "kg";
  });
});

// BMR Calculator js For Single Blog(Name :- BMR Calculator)

document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("bmrCalculateBtn");
  if (!btn) return;

  btn.addEventListener("click", function () {

    const gender = document.getElementById("bmrGender").value;
    const age = parseInt(document.getElementById("bmrAge").value);

    let heightInput = parseFloat(document.getElementById("bmrHeight").value);
    let heightUnit = document.getElementById("bmrHeightUnit").value;

    let weightInput = parseFloat(document.getElementById("bmrWeight").value);
    let weightUnit = document.getElementById("bmrWeightUnit").value;

    const output = document.getElementById("bmrOutput");

    if (!age || !heightInput || !weightInput) {
      alert("Please fill all fields");
      return;
    }

    // Convert height to cm
    let height = heightInput;
    if (heightUnit === "inch") {
      height = heightInput * 2.54;
    }

    // Convert weight to kg
    let weight = weightInput;
    if (weightUnit === "lbs") {
      weight = weightInput * 0.45359237;
    }

    // BMR formula (Mifflin–St Jeor)
    let BMR;
    if (gender === "male") {
      BMR = (10 * weight) + (6.25 * height) - (5 * age) + 5;
    } else {
      BMR = (10 * weight) + (6.25 * height) - (5 * age) - 161;
    }

    output.style.display = "block";
    output.innerHTML =
      "Your BMR is <strong>" + Math.round(BMR) + " calories/day</strong>";

    // Reset fields
    document.getElementById("bmrAge").value = "";
    document.getElementById("bmrHeight").value = "";
    document.getElementById("bmrWeight").value = "";
    document.getElementById("bmrHeightUnit").value = "cm";
    document.getElementById("bmrWeightUnit").value = "kg";
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const genderButtons = document.querySelectorAll(".bf-gender-btn");
  const hipField = document.getElementById("bfHipField");
  let selectedGender = "male";

  genderButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      genderButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      selectedGender = btn.dataset.gender;

      if (hipField) {
        hipField.style.display = selectedGender === "female" ? "block" : "none";
      }
    });
  });

  const calcBtn = document.getElementById("bfCalcBtn");

  if (calcBtn) {
    calcBtn.addEventListener("click", () => {
      let height = parseFloat(document.getElementById("bfHeight").value);
      let waist = parseFloat(document.getElementById("bfWaist").value);
      let neck = parseFloat(document.getElementById("bfNeck").value);
      let hip = parseFloat(document.getElementById("bfHip")?.value);

      const heightUnit = document.getElementById("bfHeightUnit").value;
      const waistUnit = document.getElementById("bfWaistUnit").value;
      const neckUnit = document.getElementById("bfNeckUnit").value;
      const hipUnit = document.getElementById("bfHipUnit")?.value;

      if (!height || !waist || !neck || (selectedGender === "female" && !hip)) {
        alert("Please fill all required fields");
        return;
      }

      if (heightUnit === "inch") height *= 2.54;
      if (waistUnit === "inch") waist *= 2.54;
      if (neckUnit === "inch") neck *= 2.54;
      if (selectedGender === "female" && hipUnit === "inch") hip *= 2.54;

      let bodyFat;

      if (selectedGender === "male") {
        bodyFat = 495 / (
          1.0324 - 0.19077 * Math.log10(waist - neck)
                  + 0.15456 * Math.log10(height)
        ) - 450;
      } else {
        bodyFat = 495 / (
          1.29579 - 0.35004 * Math.log10(waist + hip - neck)
                   + 0.22100 * Math.log10(height)
        ) - 450;
      }

      const resultBox = document.getElementById("bfResult");
      resultBox.style.display = "block";
      resultBox.innerHTML = `Body Fat: <b>${bodyFat.toFixed(1)}%</b>`;
    });
  }

});

// Protine 

document.getElementById("proteinCalculateBtn").addEventListener("click", function () {

  let gender = document.getElementById("proteinGender").value;
  let age = parseFloat(document.getElementById("proteinAge").value);
  let height = parseFloat(document.getElementById("proteinHeight").value);
  let heightUnit = document.getElementById("proteinHeightUnit").value;
  let weight = parseFloat(document.getElementById("proteinWeight").value);
  let weightUnit = document.getElementById("proteinWeightUnit").value;
  let goal = document.getElementById("proteinGoal").value;

  if (!weight || !height || !age) {
    alert("Please fill all fields correctly");
    return;
  }

  // Convert units
  if (weightUnit === "lbs") weight *= 0.453592;
  if (heightUnit === "inch") height *= 2.54;

  // Base multipliers
  let min = 0, max = 0;

  if (goal === "maintenance") {
    min = max = 0.8;
  } else if (goal === "muscle") {
    min = 1.2;
    max = 2.0;
  } else if (goal === "fatloss") {
    min = 1.5;
    max = 2.2;
  }

  // Height factor
  let heightFactor = height / 170;

  // Gender factor
  let genderFactor = (gender === "male") ? 1.05 : 0.95;

  // Age factor
  let ageFactor = 1;
  if (age >= 30 && age < 50) {
    ageFactor = 1.05;
  } else if (age >= 50) {
    ageFactor = 1.1;
  }

  let minProtein = weight * min * heightFactor * genderFactor * ageFactor;
  let maxProtein = weight * max * heightFactor * genderFactor * ageFactor;

  const output = document.getElementById("proteinOutput");

  if (min === max) {
    output.innerHTML = `You need approximately <strong>${minProtein.toFixed(1)}g</strong> protein per day.`;
  } else {
    output.innerHTML = `You need <strong>${minProtein.toFixed(1)}g - ${maxProtein.toFixed(1)}g</strong> protein per day.`;
  }

  output.style.display = "block";
}); 



// One Rep Max Calculator blog: One Rep Max Calculator: Lift Smarter, Not Harder
let currentUnit = 'kg';

const percentageTable = [
  { reps: 1, pct: 100 },
  { reps: 2, pct: 95 },
  { reps: 3, pct: 93 },
  { reps: 4, pct: 90 },
  { reps: 5, pct: 87 },
  { reps: 6, pct: 85 },
  { reps: 7, pct: 83 },
  { reps: 8, pct: 80 },
  { reps: 9, pct: 77 },
  { reps: 10, pct: 75 },
  { reps: 11, pct: 70 },
  { reps: 12, pct: 67 }
];

function selectGender(element) {
  document.querySelectorAll('.crm-toggle-btn').forEach(btn => btn.classList.remove('active'));
  element.classList.add('active');
}

function setUnit(unit) {
  currentUnit = unit;
  document.getElementById('lbsBtn').classList.toggle('active', unit === 'lbs');
  document.getElementById('kgBtn').classList.toggle('active', unit === 'kg');
  
  const unitLabels = document.querySelectorAll('.unit-label');
  unitLabels.forEach(label => label.innerText = unit.toUpperCase());

  if (document.getElementById('resultSection').style.display === 'block') {
      calculateOneRepMax();
  }
}

function updateReps(val) {
  document.getElementById('repsValue').innerText = val;
}

function calculateOneRepMax() {
  const weight = parseFloat(document.getElementById('weightInput').value);
  const reps = parseInt(document.getElementById('repsSlider').value);
  
  if (!weight || weight <= 0) {
    alert("Please enter a valid weight.");
    return;
  }

  // --- EPLEY FORMULA ---
  // 1. Calculate precise unrounded 1RM for table calculations
  let precise1RM = weight * (1 + (reps / 30));
  
  // 2. Create a rounded version ONLY for the Header text (1 decimal)
  let display1RM = Math.round(precise1RM * 10) / 10;

  // Update Header
  document.getElementById('header1RM').innerText = `${display1RM} ${currentUnit}`;

  // Generate Table using PRECISE 1RM
  const tbody = document.getElementById('resultTableBody');
  tbody.innerHTML = ''; 

  percentageTable.forEach(row => {
    if (row.reps === 1) return; 

    // Use precise1RM here to avoid "double rounding" errors
    let rowWeight = precise1RM * (row.pct / 100);
    
    // Now round the final table row value
    rowWeight = Math.round(rowWeight * 10) / 10;

    const tr = document.createElement('tr');
    tr.innerHTML = `
      <td>${row.reps}RM</td>
      <td>${row.pct}%</td>
      <td>${rowWeight}</td>
    `;
    tbody.appendChild(tr);
  });

  document.getElementById('resultSection').style.display = 'block';
}


(function () {
  function initOrdergroovePdpRecovery() {
    const offerSelector = '.product__info-container og-offer';
    const offers = document.querySelectorAll(offerSelector);
    if (!offers.length) return;

    const fallbackPriceEls = document.querySelectorAll('.product__price-fallback');
    const ordergrooveScript = document.querySelector('script[src*="static.ordergroove.com"][data-shopify-selling-plans]');
    let scriptRetries = 0;
    let remountAttempted = false;

    const getActiveVariantId = () => {
      const activeVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      return activeVariantInput ? activeVariantInput.value : null;
    };

    const setFallbackPriceVisibility = (hideFallback) => {
      fallbackPriceEls.forEach((priceEl) => {
        priceEl.style.display = hideFallback ? 'none' : '';
      });
    };

    const syncOfferVariant = () => {
      const activeVariantId = getActiveVariantId();
      if (!activeVariantId) return;

      document.querySelectorAll(offerSelector).forEach((offerEl) => {
        if (offerEl.getAttribute('product') !== activeVariantId) {
          offerEl.setAttribute('product', activeVariantId);
        }
      });
    };

    const isOfferHydrated = () => {
      return Array.from(document.querySelectorAll(offerSelector)).some((offerEl) => {
        const ogPrice = offerEl.querySelector('og-price');
        const hasVisiblePrice = ogPrice && ogPrice.textContent.trim().length > 0 && 
                                 window.getComputedStyle(ogPrice).display !== 'none';
        // Only consider hydrated if there's actually a visible price
        // Don't hide fallback just because other OG elements exist
        return Boolean(hasVisiblePrice);
      });
    };

    const retryOrdergrooveScript = () => {
      if (!ordergrooveScript || scriptRetries >= 2) return;

      scriptRetries += 1;
      const retryScript = ordergrooveScript.cloneNode(true);
      retryScript.async = true;
      retryScript.setAttribute('data-nb-og-retry', String(scriptRetries));
      document.head.appendChild(retryScript);
    };

    const remountOffers = () => {
      document.querySelectorAll(offerSelector).forEach((offerEl) => {
        const replacement = document.createElement('og-offer');
        Array.from(offerEl.attributes).forEach((attribute) => {
          replacement.setAttribute(attribute.name, attribute.value);
        });
        offerEl.replaceWith(replacement);
      });

      syncOfferVariant();
    };

    const recoverOffer = () => {
      syncOfferVariant();

      if (!customElements.get('og-offer')) {
        setFallbackPriceVisibility(false);
        retryOrdergrooveScript();
        return;
      }

      const hydrated = isOfferHydrated();
      setFallbackPriceVisibility(hydrated);

      if (!hydrated && !remountAttempted) {
        remountAttempted = true;
        remountOffers();
        setTimeout(() => {
          const stillHydrated = isOfferHydrated();
          setFallbackPriceVisibility(stillHydrated);
          // Safety check: if Ordergroove still hasn't shown a price, ensure fallback is visible
          if (!stillHydrated) {
            setFallbackPriceVisibility(false);
          }
        }, 400);
      }
    };

    const variantContainer = document.querySelector('variant-selects[data-section], variant-radios[data-section]');
    if (variantContainer) {
      variantContainer.addEventListener('change', () => {
        setTimeout(recoverOffer, 150);
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        recoverOffer();
      }
    });

    window.addEventListener('load', () => {
      setTimeout(recoverOffer, 500);
      setTimeout(recoverOffer, 2500);
      // Final safety check to ensure prices are always visible
      setTimeout(() => {
        const anyPriceVisible = document.querySelector('.price-item:not([style*="display: none"])') ||
                                document.querySelector('og-price:not([style*="display: none"])');
        if (!anyPriceVisible) {
          // Force fallback prices to show if no prices are visible at all
          setFallbackPriceVisibility(false);
        }
      }, 3000);
    });

    setTimeout(recoverOffer, 1000);
    setTimeout(recoverOffer, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrdergroovePdpRecovery);
  } else {
    initOrdergroovePdpRecovery();
  }
})();
